import { useCallback, useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../lib/api";
import ProductWorkQueues from "../components/ProductWorkQueues";
import FocusCommandPage from "./FocusCommandPage";

export default function LincWerksPrimaryPage() {
  const navigate = useNavigate();
  const [items, setItems] = useState([]);
  const [businesses, setBusinesses] = useState([]);

  const loadQueues = useCallback(async () => {
    try {
      const [{ data: focusItems }, { data: biz }] = await Promise.all([
        api.get("/focus_items?status=open&limit=300"),
        api.get("/businesses"),
      ]);
      setItems(Array.isArray(focusItems) ? focusItems : []);
      setBusinesses(Array.isArray(biz) ? biz : []);
    } catch {
      // FocusCommandPage remains fully usable if queue aggregates are unavailable.
    }
  }, []);

  useEffect(() => { loadQueues(); }, [loadQueues]);

  const queueItems = useMemo(() => items.filter((item) => item.status === "open"), [items]);

  const openProduct = (key) => {
    if (!key || key === "unassigned") return;
    if (key === "linkforge") { navigate("/linkforge"); return; }
    if (key === "gearlinc") { navigate("/gearlinc"); return; }
    navigate(`/businesses/${key}`);
  };

  const openItem = (item) => {
    const missionId = item?.mission_id || item?.source_ref?.mission_id;
    if (missionId) { navigate(`/commandlinc/missions/${missionId}`); return; }
    if (item?.business_key) { openProduct(item.business_key); return; }
    navigate("/focus/classic");
  };

  return (
    <div data-testid="lincwerks-primary-workspace" data-edit-name="FocusLinc">
      <section className="panel" style={{ marginBottom: 14 }} data-testid="product-centered-work-queues" data-edit-name="Product work queues">
        <div className="panel-head">
          <div>
            <h2>Product work queues</h2>
            <p>NOW · NEXT · NEEDS YOU · blocked/risk · AI handling</p>
          </div>
          <button className="btn small" onClick={loadQueues}>Refresh</button>
        </div>
        <div className="panel-body">
          <ProductWorkQueues
            items={queueItems}
            businesses={businesses}
            onOpenProduct={openProduct}
            onOpenItem={openItem}
          />
        </div>
      </section>
      <FocusCommandPage />
    </div>
  );
}
